import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { homeGetHomeInitialData, pollLiveMatch } from '../redux/actions/Home';
import {
  liveMatchId,
  isMatchLive,
  cacheLiveMatchSnapshot,
} from '../service/liveMatch';

const LIVE_POLL_MS = 15000;

export default function useLiveMatchPoll(matchRunning) {
  const dispatch = useDispatch();
  const matchId = liveMatchId(matchRunning);
  const isLive = isMatchLive(matchRunning);

  // Keep a tab cache so Match Info survives hard reload while GET /league/match 404s.
  useEffect(() => {
    if (!isLive || !matchRunning || typeof matchRunning !== 'object') return;
    cacheLiveMatchSnapshot(matchRunning, [matchId]);
  }, [isLive, matchId, matchRunning]);

  useEffect(() => {
    if (!isLive) return undefined;

    let cancelled = false;

    const tick = () => {
      if (cancelled || (typeof document !== 'undefined' && document.hidden)) {
        return;
      }
      // Dedicated match endpoint 404s until FT — refresh /home every tick for live state.
      dispatch(homeGetHomeInitialData());
      if (matchId) {
        dispatch(pollLiveMatch(matchId));
      }
    };

    tick();
    const interval = setInterval(tick, LIVE_POLL_MS);
    const onVisibility = () => {
      if (!document.hidden) tick();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [dispatch, isLive, matchId]);
}
